/* Replace the existing styles with these improved ones */

.mmContainer {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  background-color: #F7F9FC;
  min-height: 100vh;
}

/* Header styling */
.header {
  background: linear-gradient(135deg, #635BFF 0%, #7C3AED 100%);
  color: white;
  padding: 40px 0;
  margin-bottom: 30px;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  position: relative;
}

.headerContent {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.headerRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.backButton {
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.backButton:hover {
  background-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-1px);
}

/* Content Layout */
.contentLayout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 30px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Sidebar styling */
.mmSidebar {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #E2E8F0;
  height: fit-content;
  position: sticky;
  top: 20px;
}

.mmSectionTitle {
  font-size: 18px;
  font-weight: 600;
  color: #2D3748;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #EBF4FF;
}

/* Category List */
.mmCategoryList {
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;
}

.mmCategoryButton {
  width: 100%;
  text-align: left;
  background: #F7FAFC;
  border: 1px solid #E2E8F0;
  color: #4A5568;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.mmCategoryButton:hover {
  background-color: #EDF2F7;
  border-color: #CBD5E0;
  transform: translateY(-1px);
}

.mmSelected {
  background: linear-gradient(135deg, #635BFF 0%, #7C3AED 100%);
  color: white;
  border-color: #635BFF;
  box-shadow: 0 2px 8px rgba(99, 91, 255, 0.2);
}

.mmSelected:hover {
  background: linear-gradient(135deg, #574CE0 0%, #6D28D9 100%);
}

/* Add Category Form */
.mmAddCategoryForm {
  background: #F7FAFC;
  padding: 16px;
  border-radius: 8px;
  border: 2px dashed #CBD5E0;
  margin-bottom: 16px;
}

.mmAddButton {
  width: 100%;
  background: #EBF4FF;
  color: #635BFF;
  border: 2px dashed #635BFF;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.mmAddButton:hover {
  background: #635BFF;
  color: white;
  border-color: #635BFF;
}

/* Main Content Area */
.mmMainContent {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #E2E8F0;
}

.mmSectionHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #EBF4FF;
}

.mmSectionTitle {
  font-size: 20px;
  font-weight: 600;
  color: #2D3748;
  margin: 0;
}

/* Menu Grid */
.mmMenuGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  margin-top: 24px;
}

.mmMenuItem {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #E2E8F0;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
}

.mmMenuItem:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  border-color: #635BFF;
}

/* Menu Item Image */
.mmMenuItemImageContainer {
  width: 100%;
  height: 180px;
  overflow: hidden;
  background: #F7FAFC;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mmMenuItemImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.mmMenuItem:hover .mmMenuItemImage {
  transform: scale(1.05);
}

/* Menu Item Content */
.mmMenuItemHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 16px 8px 16px;
}

.mmMenuItemName {
  font-weight: 600;
  font-size: 16px;
  color: #2D3748;
  margin: 0;
}

.mmMenuItemPrice {
  font-weight: 700;
  color: #635BFF;
  font-size: 16px;
}

.mmMenuItemDesc {
  color: #718096;
  font-size: 14px;
  line-height: 1.5;
  padding: 0 16px;
  margin-bottom: 16px;
}

.mmMenuItemFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #F7FAFC;
  border-top: 1px solid #E2E8F0;
}

/* Status Badge */
.mmItemStatus {
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mmAvailable {
  background: #C6F6D5;
  color: #22543D;
}

.mmUnavailable {
  background: #FED7D7;
  color: #742A2A;
}

/* Action Buttons */
.mmMenuItemActions {
  display: flex;
  gap: 8px;
}

.mmEditButton, .mmDeleteButton {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.mmEditButton {
  background: #EBF4FF;
  color: #635BFF;
}

.mmEditButton:hover {
  background: #635BFF;
  color: white;
}

.mmDeleteButton {
  background: #FED7D7;
  color: #E53E3E;
}

.mmDeleteButton:hover {
  background: #E53E3E;
  color: white;
}

/* Buttons */
.mmPrimaryButton {
  background: linear-gradient(135deg, #635BFF 0%, #7C3AED 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mmPrimaryButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(99, 91, 255, 0.3);
}

.mmSecondaryButton {
  background: #F7FAFC;
  color: #4A5568;
  border: 1px solid #E2E8F0;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mmSecondaryButton:hover {
  background: #EDF2F7;
  border-color: #CBD5E0;
}

/* Form Elements */
.mmFormGroup {
  margin-bottom: 20px;
}

.mmFormGroup label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #2D3748;
}

.mmInput, .mmFormGroup input, .mmFormGroup textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.mmInput:focus, .mmFormGroup input:focus, .mmFormGroup textarea:focus {
  outline: none;
  border-color: #635BFF;
  box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.1);
}

/* Modal Styles */
.mmModal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.mmModalContent {
  width: 95%;
  max-width: 500px;
  background-color: white;
  border-radius: 12px;
  padding: 30px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.mmModalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E2E8F0;
}

.mmModalHeader h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2D3748;
}

.mmCloseButton {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #A0AEC0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.mmCloseButton:hover {
  background: #F7FAFC;
  color: #4A5568;
}

/* Empty State */
.mmEmptyState {
  text-align: center;
  padding: 60px 30px;
  background: #F7FAFC;
  border-radius: 12px;
  border: 2px dashed #CBD5E0;
  color: #718096;
}

.mmEmptyState h3 {
  font-size: 18px;
  margin: 16px 0 8px 0;
  color: #4A5568;
}

.mmEmptyState p {
  margin: 0 0 24px 0;
  font-size: 14px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .contentLayout {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .mmSidebar {
    position: static;
  }
  
  .mmMenuGrid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .mmContainer {
    padding: 0 16px;
  }
  
  .mmMainContent {
    padding: 20px;
  }
  
  .mmMenuGrid {
    grid-template-columns: 1fr;
  }
  
  .contentLayout {
    padding: 0 16px;
  }
}